// Copyright 2023 Sorama B.V.
import { bindable } from "aurelia-templating";
import { ReportableMeasurement } from "datatypes/ReportableMeasurement";

export class ReportTemplate<T> {
    @bindable({ changeHandler: "reportChanged" })
    public report: ReportableMeasurement<T>;

    protected get data(): T {
        return this.report.data;
    }

    public reportChanged(): void {}

    protected smallText = "";
}
